import http from '../common/http-auth'
import type {RemoveUnsubscribeListType} from '../components/types/types';


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllUnsubscribeEmail = async () => {
    const response = await http.get(`/unsubscribeemaillist/all`);
    return response;
};


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const removeEmailsFromUnsubscribeList = async (data: RemoveUnsubscribeListType) => {
    const response = http.post(`/unsubscribeemaillist/removeemailsfromunsubscribelist`, data)
    return response;
}
